/**
 * Clearing the brand clears the model with it.
 *
 * A model like "Datejust" means nothing without its brand, so the Model filter is only
 * rendered once a single brand is in play (see the show_model_filter rule in
 * sections/main-collection-product-grid.liquid). Dropping the brand while a model is
 * selected therefore leaves the model still applied but with nowhere to unset it.
 *
 * The brand cards handle this themselves: their URLs are built with the model parameter
 * stripped. The filter drawer cannot, because it is a form of checkboxes that the theme
 * submits wholesale, so unticking Brand there would carry the still-ticked Model along.
 * This unticks the Model boxes at the moment the last Brand box is cleared, before the
 * theme reads the form.
 *
 * Listens on capture so it runs before the theme's own change handler submits.
 */

const VENDOR = 'filter.p.vendor';
const MODEL = 'filter.p.m.custom.model';

class CollectionModelGuard extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.section');
    if (!this.section) return;
    this.onChange = this.#handleChange.bind(this);
    this.section.addEventListener('change', this.onChange, true);
  }

  disconnectedCallback() {
    if (this.section && this.onChange) {
      this.section.removeEventListener('change', this.onChange, true);
    }
  }

  #handleChange(event) {
    const input = event.target;
    if (!input || input.name !== VENDOR) return;

    const form = input.closest('form');
    if (!form) return;

    const brandStillChosen = Array.from(form.querySelectorAll(`input[name="${VENDOR}"]`)).some(
      (el) => el.checked
    );
    if (brandStillChosen) return;

    form.querySelectorAll(`input[name="${MODEL}"]`).forEach((el) => {
      el.checked = false;
    });
  }
}

if (!customElements.get('collection-model-guard')) {
  customElements.define('collection-model-guard', CollectionModelGuard);
}
